<template>
      <table class="table table-sm" style="margin-bottom:6px;" v-if="datatable">
        <thead>
          <tr>
            <th colspan="2">Locations</th>
            <th :colspan="numCols" class="text-center">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, n) in datatable">
            <td style="padding-right:5px">{{n+1}}</td>
            <td style="padding-right:0px;"><nobr>{{row.lat.toFixed(4)}}, {{row.lng.toFixed(4)}}</nobr></td>
            <td class="value" v-for="col in row['data']" v-html="fmtNumber(col)"></td>
          </tr>
        </tbody>
      </table>

</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import _ from 'lodash';


export default {
    name: 'RasterMapDataTable',
    components: { },
    props: ['datatable'],
    data() {
      return {};
    },
    watch: {
      datatable() {
        console.log("Datatable updated!@!")
      }
    },
    computed: {
      numCols() {
        if(this.datatable.length > 0) {
          return this.datatable[0]['data'].length ;
        } else {
          return 0;
        }        
      },
      numRows() {
        if(this.datatable.length > 0) {
          return this.datatable.length ;
        } else {
          return 0;
        }
      },
    },
    methods: {
      fmtNumber(value) {
        if(value==null) {
          return "&ndash;"
        } else {
          return value.toFixed(2)
        }
      },
    }
    
}
</script>

<style scoped>
table {
  width:100%;
  background-color:#fff;
}
table td, table th {
  margin:0px;
  padding:3px 0px;
  vertical-align:middle;
}
table td.value {
  padding:0px 3px;
  text-align:center;
}
</style>